import { Link } from "react-router-dom";
import "./headerbanner.css";
import { MdKeyboardArrowRight } from "react-icons/md";
import Gown from "../../Media/Photos Gallery/gal13.png";

export default function HeaderBanner({ title, currentPath }) {
  return (
    <div className="header-banner">
      <div className="header-content">
        <h1>{title}</h1>
        <nav className="breadcrumb">
          <Link to="/">Home</Link>
          <MdKeyboardArrowRight />
          <span className="breadcrumb-current">{currentPath}</span>
        </nav>
      </div>
      <div className="header-image">
        <img
          src={Gown}
          alt="banner background"
        />
      </div>
    </div>
  );
}
